export const GREG_LAB_LOBBY_URL = 'https://games.greglab.net';

function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  const value = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
  if (!value) return null;
  try {
    return decodeURIComponent(value.slice(prefix.length));
  } catch {
    return null;
  }
}

export const glIdentity = {
  token: readCookie('gl_player'),
  name: readCookie('gl_name'),
};

export async function fetchGregLabDisplayName(): Promise<string | null> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 5_000);
  try {
    const response = await fetch(`${GREG_LAB_LOBBY_URL}/api/me`, {
      credentials: 'include',
      cache: 'no-store',
      signal: controller.signal,
    });
    if (!response.ok) return null;
    const body: unknown = await response.json();
    if (!body || typeof body !== 'object' || !('profile' in body)) return null;
    const profile = body.profile;
    if (!profile || typeof profile !== 'object' || !('displayName' in profile) || typeof profile.displayName !== 'string') return null;
    return profile.displayName.trim() || null;
  } catch {
    return null;
  } finally {
    window.clearTimeout(timeout);
  }
}
